import { render, staticRenderFns } from "./RedactorInput.vue?vue&type=template&id=d3a5bf90"
import script from "./RedactorInput.vue?vue&type=script&lang=js"
export * from "./RedactorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports